import { LoadUTM } from "../../common/constants/functions/LoadUTM";
import { CalculatorForm } from "../../common/constants/forms/CalculatorForm";
import { ContactForm } from "../../common/constants/forms/ContactForm";
import { GetDataCalculator } from "../../modules/calculators/GetDataCalculator";
import { formState } from "./FormState";
import { GetProjectForm } from "./GetProjectForm";
import { ValidateFields } from "./ValidateFields";
import { loadDataAVI } from "../../common/constants/functions/loadDataAVI";
// Creating instances of the necessary classes
const project = new GetProjectForm(formState);
const validateForm = new ValidateFields(formState);
const loadUtm = new LoadUTM(formState);
const loadData = new loadDataAVI(formState);
let sendForm = null;
const sendFormCalculator = new CalculatorForm(formState);
export const dataCalculator = new GetDataCalculator(formState);
// Exposing methods to the global window object for external usage
window.projectForm = project.getDataForm;
window.changeInputRadio = validateForm.changeInputRadio;
window.changeSelectCountryCode = validateForm.changeSelectCountryCode;
window.changeCheckbox = validateForm.changeCheckbox;
window.changeSelect = validateForm.changeSelect;
window.validateInputs = validateForm.validateInputs;
window.saveContactMedium = loadData.saveContactMedium;
window.openAVI = (nid) => loadData.loadAVIChat(nid);
window.send = (_contactModal) => {
    if (!sendForm) {
        sendForm = new ContactForm(formState);
    }
    sendForm.submitForm();
};
window.sendCalculus = sendFormCalculator.submitForm;
// instances of calculator
window.setUpInfoModal = dataCalculator.setUpInfoModal;
window.closeCalculusModal = dataCalculator.closeCalculusModal;
window.changeModal = dataCalculator.changeModal;
window.calculateFormMortgage = dataCalculator.calculateFormMortgage;
document.addEventListener('DOMContentLoaded', () => {
    // Validating the form when the page loads
    validateForm.validateForm(); // Call validateForm to check if the form is correctly filled out
    // Set up event listeners for inputs to calculators
    dataCalculator.loadCalculator();
    const triggers = document.querySelectorAll('.js-country-code-trigger');
    triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            project.setCountryCode();
        });
    });
});
// Saving UTM parameters to sessionStorage if not already stored
loadUtm.saveUtmParams(); // Call saveUtmParams to store UTM parameters from the URL to sessionStorage
loadData.saveDataParams();
